window.onload = (event) => {
  document.querySelectorAll('.masonry-image-block-item img').forEach(function(imgElement) {
    imgElement.addEventListener('click', function() {
      let dataTitle = imgElement.getAttribute('data-title');

      const elementToMove = document.getElementById('9LPWXBaM8z3cK66UYunglg');
      const targetContainer = document.getElementById('modalFormContainer');
      
      if (elementToMove && targetContainer) {
        targetContainer.appendChild(elementToMove);
      } else {
        console.error('One or both of the elements were not found.');
      }

      setTimeout(function() {
        let iframe = document.querySelector('#frame_9LPWXBaM8z3cK66UYunglg');
        if (iframe) {
          iframe.contentWindow.postMessage({ title: dataTitle }, '*');
        }
      }, 3000); // Adjust the delay as necessary

      document.getElementById('formModal').style.display = 'block';
    });
  });

  console.log('loaded');

  document.querySelector('.modal .close').addEventListener('click', function() {
    document.getElementById('formModal').style.display = 'none';
  });

  document.getElementById('formModal').addEventListener('click', function(event) {
    if (event.target === this) {
      this.style.display = 'none';
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.keyCode === 27) { // 27 is the keycode for the Escape key
      document.getElementById('formModal').style.display = 'none';
    }
  });

  window.addEventListener('message', function(event) {
    var data = event.data.title;
    var formInput = document.querySelector('.formElement_10 input[type="hidden"]');
    if (formInput) {
      formInput.value = data;
    }
  });
};
